import React from "react";
import { ControlLabel, Button, Alert, FormControl, Checkbox } from "react-bootstrap";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from 'immutable';
import { browserHistory } from "react-router";
import util from "./../lib/util.js";

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            siteTitle: '',
            showMaintenanceMessage: false,
            systemMaintenanceMessage: '',
            passwordLabel: '',
            emailAddressLabel: '',
            loginLabel: '',
            rememberMeLabel: '',
            enterDomainUserPasswordLabel: '',
            domainUsernameRequiredMessage: '',
            passwordRequiredMessage: '',
            errorMessage: '',
            errors: []
        };

        this.usernameChange = this.usernameChange.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.loginClick = this.loginClick.bind(this);
        this.loadLoginViewModel = this.loadLoginViewModel.bind(this);
        this.forgotPasswordClick = this.forgotPasswordClick.bind(this);
        this.rememberMeChange = this.rememberMeChange.bind(this);
    }

    componentWillMount() {
        const self = this;
        const msgCode = self.props.location.query.msgcode;

        if (msgCode) {
            let msg = context.resolveMsg(msgCode);
            if (msg) {
                let clone = immutable.fromJS(self.state);
                clone.errors = [msg];
                self.setState(clone);
            }
        }
    }

    componentDidMount() {
        var returnUrl = util.getQueryStringValue('ReturnUrl');

        if (returnUrl !== undefined) {
            if (returnUrl.indexOf('/app/reset-password') > -1) {
                returnUrl = returnUrl.split('/app/')[1];
                browserHistory.push(context.routeUrl(returnUrl));
            }
            else if (returnUrl == '/app/forgot-password') {
                browserHistory.push(context.routeUrl('forgot-password'));
            }
            else if (returnUrl.indexOf('/app/activate-inactive-user') > -1) {
                returnUrl = returnUrl.split('/app/')[1];
                console.log(returnUrl);
                browserHistory.push(context.routeUrl(returnUrl));
            }
            else {
                this.loadLoginViewModel();
            }
        }
        else {
            this.loadLoginViewModel();
        }
    }

    loadLoginViewModel() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        ajax.api()
            .get("clear-mfa-cookie")
            .catch(function (err) {
                let data = err.response.data;
                console.log(data);
                context.message({ show: true, type: "error", message: data.exceptionMessage || data.message, buttons: "close" });
            });

        ajax.vm().get("login")
            .then(function (res) {
                self.setState({
                    siteTitle: res.data.siteTitle,
                    showMaintenanceMessage: res.data.showMaintenanceMessage,
                    systemMaintenanceMessage: res.data.systemMaintenanceMessage,
                    passwordLabel: res.data.passwordLabel,
                    emailAddressLabel: res.data.emailAddressLabel,
                    loginLabel: res.data.loginLabel,
                    rememberMeLabel: res.data.rememberMeLabel,
                    enterDomainUserPasswordLabel: res.data.enterDomainUserPasswordLabel,
                    notAUserForgotCredentialsLabel: res.data.notAUserForgotCredentialsLabel,
                    domainUsernameRequiredMessage: res.data.domainUsernameRequiredMessage,
                    passwordRequiredMessage: res.data.passwordRequiredMessage,
                    cantAccessYourAccountLabel: res.data.cantAccessYourAccountLabel
                });
                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    usernameChange(event) {
        let value = event.target.value.trim();
        this.setState({
            username: value
        });
    }

    rememberMeChange(evt) {
        this.setState({
            rememberMe: evt.target.checked
        });
    }

    passwordChange(event) {
        let value = event.target.value.trim();
        this.setState({
            password: value
        });
    }

    loginClick() {
        var messages = this.validate();
        this.setState({
            errors: messages,
            reportData: null
        });

        if (messages.length == 0) {
            this.login();
        }
    }

    login() {
        let self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Authenticating. Please wait..."
        });

        ajax.api().post(`authenticate-user`,
            {
                username: self.state.username,
                password: self.state.password,
                isEmail: util.isEmail(self.state.username),
                rememberMe: !!(self.state.rememberMe)
            }
        )
            .then(function (res) {
                if (res.data.isAuthenticated && res.data.requirePasswordChange) {
                    window.location = context.root() + '/' + res.data.returnUrl;
                }
                else if (res.data.isAuthenticated) {
                    if (res.data.returnUrl.indexOf('.aspx') >= 0) {
                        window.location = context.root().replace('v2/', '').replace('v2', '') + res.data.returnUrl;
                    }
                    else {
                        window.location = context.root() + '/' + res.data.returnUrl;
                    }
                }
                else if (res.data.errorMessage !== undefined && res.data.errorMessage != '') {
                    let msg = [];
                    msg.push(res.data.errorMessage);
                    self.setState({
                        errors: msg
                    });
                    context.message({ show: false });
                }
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    validate() {
        let msg = [];

        if (this.state.username.length == 0) {
            msg.push(this.state.domainUsernameRequiredMessage);
        }

        if (this.state.password.length == 0) {
            msg.push(this.state.passwordRequiredMessage);
        }

        return msg;
    }

    forgotPasswordClick() {
        browserHistory.push(context.routeUrl('forgot-password'));
    }

    render() {
        var rowStyle = {
            paddingTop: "10px"
        };
        const self = this;
        return (
            <div className="ap-fullheight">
                <section className="ap-l-section ap-section-hero login ap-fullheight">
                    <form onSubmit={evt => { evt.preventDefault(); return false; }}>
                        <div className="container ap-fullheight">
                            <div className="row">
                                <h2 className="text-center">{this.state.siteTitle}</h2>
                            </div>
                            <div className="row text-center">
                                <div onKeyUp={(evt) => {
                                    if (evt.keyCode === 13) self.loginClick();
                                }}
                                    className="container-fluid">
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 small-text-center login-label">
                                            {this.state.enterDomainUserPasswordLabel}
                                        </div>
                                    </div>
                                    <div className="row" style={rowStyle}>
                                        <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6 login-control">

                                            <FormControl type="text" placeholder={this.state.emailAddressLabel}
                                                defaultValue={this.state.username}
                                                onChange={this.usernameChange}
                                                className="login-input"></FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6 login-control">

                                            <FormControl type="password" placeholder={this.state.passwordLabel}
                                                defaultValue={this.state.password}
                                                onChange={this.passwordChange}
                                                className="login-input"></FormControl>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                            <Checkbox defaultChecked={false}
                                                onChange={this.rememberMeChange}>{this.state.rememberMeLabel}</Checkbox>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6">
                                            <Button onClick={this.loginClick} className="btn btn-info ap-fullsize">{this.state.loginLabel}</Button>
                                        </div>
                                        <div className="col-md-4 col-lg-4"></div>
                                    </div>
                                    {/* <div className="row" style={rowStyle}>
                                    <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8 small-text-center login-label">
                                        {this.state.notAUserForgotCredentialsLabel}
                                    </div>
                                </div> */}
                                    <div className="row" style={rowStyle}>
                                        <div className="col-md-offset-3 col-lg-offset-3 col-md-6 col-lg-6 login-label">
                                            <a href="javascript:void(0)" onClick={this.forgotPasswordClick}>{this.state.cantAccessYourAccountLabel}</a>
                                        </div>
                                    </div>

                                    <div className="row" style={rowStyle}>
                                        <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">

                                            <Alert bsStyle="danger" className={this.state.showMaintenanceMessage == true ? "" : "ap-hidden"}>
                                                <ul className="text-left">
                                                    <li>{this.state.systemMaintenanceMessage}</li>
                                                </ul>
                                            </Alert>

                                        </div>
                                    </div>
                                    <div className="row" style={rowStyle}>
                                        <div className="col-md-offset-2 col-lg-offset-2 col-md-8 col-lg-8">
                                            <Alert bsStyle="danger" className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                                <ul className="text-left">
                                                    {this.state.errors.map(m =>
                                                        <li key={m}>{m}</li>)}
                                                </ul>
                                            </Alert>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        );
    }
}